export const ROUTES = {
    HOME: {
        isExact: true,
        label: 'Home',
        path: '/',
        showInNavBar: true,
    },
    // ALBUMS: {
    //     isExact: false,
    //     label: 'Albums',
    //     path: '/albums'
    // },
    // ALBUM: {
    //     label: 'Album',
    //     path: '/albums/:id',
    //     showInNavBar: false,
    // },
    ABOUT: {
        isExact: true,
        label: 'About',
        path: '/about',
        showInNavBar: true,
    },
}